module.exports = __webpack_public_path__ + "img/es-07.4cbac453.svg";